<template>
    <div :class="['wrapper--page page-inner', name, { 'reverse': reverse }]">

        <div class="page__wrap top">
            <arrow-button
                type="top"
                text="Back"
                :label="backButton.label"
                @click.native="() => $router.push(backButton.route)"
            />
        </div>

        <page-main tag="main" class="wrapper--body">
            <transition appear name="load" mode="out-in">
                <slot name="body" />
            </transition>
    
            <transition appear name="load">
                <PageNav 
                    v-bind="{ navTitle, navTitleId, routeName, items }"
                />
            </transition>
        </page-main>

        <SlideLines />

        <PageFooter />

    </div>
</template>

<script>
import gsap from 'gsap'

import PageNav      from './PageNav'
import SlideLines   from './Slide/SlideLines'
import PageFooter   from './PageFooter.vue'

export default {
    props: {
        navTitle: String,
        navTitleId: String,
        routeName: String,
        name: {
            type: String,
            default: 'members'
        },
        reverse: {
            type: Boolean,
            default: false
        },
        backButton: {
            type: Object,
            required: true
        },
        items: {
            type: [Array, Object],
            required: true
        },
        bullets: {
            type: [Array, Object],
            required: false
        },
    },
    
    components: {
        PageNav,
        SlideLines,
        PageFooter,
    },

    created() {
        this.rootClass('rm')
        this.mobileClass('add', '-viewport')
    },

    activated() {
        this.rootClass('rm')
        this.mobileClass('add', '-viewport')

        gsap.to( document.body, {
            scrollTop: 0,
            duration: 0,
        })
    },
}
</script>